<ng-template #proofAmountSummary>
  <ng-container
    *ngIf="
      finalAmount !== null && finalAmount !== undefined;
      else proofAmountFallback
    "
  >
    <gatewee-amount-fee-breakdown
      class="gw-w-full"
      [amount]="amount"
      [calculatedFee]="calculatedFee"
      [finalAmount]="finalAmount"
      inputMode="deductFees"
      variant="compact"
    ></gatewee-amount-fee-breakdown>
  </ng-container>
  <ng-template #proofAmountFallback>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0 gw-font-normal">
        {{ 'features.withdrawals.modalPix.proofSentValue' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ form.get('amount')?.value | currency : 'BRL' }}
      </p>
    </div>
  </ng-template>
</ng-template>

<ng-container *ngIf="isWithdrawalPolling">
  <div
    class="gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-small gw-mb-medium"
  >
    <gatewee-icon
      icon="@phi.clock"
      class="gw-text-status-warning gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <span
      class="gw-text-center gw-text-text-primary gw-text-[16px] gw-font-extrabold"
    >
      {{ 'features.withdrawals.modalPix.transferPending' | translate }}
    </span>
    <p
      class="gw-text-center gw-text-text-secondary gw-text-base gw-m-0 gw-max-w-[280px]"
    >
      {{ 'features.withdrawals.modalPix.transferPendingSummary' | translate }}
    </p>
  </div>
  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>
    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ confirmedBankDisplayLine | uppercase }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ resolvedRecipientName | uppercase }}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isWithdrawalSuccess">
  <div class="gw-flex gw-items-center gw-gap-small gw-mb-medium">
    <gatewee-icon
      icon="@phi.check-circle"
      class="gw-text-status-info gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <div class="gw-flex gw-flex-col">
      <span class="gw-text-text-primary gw-text-[16px] gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.transferSuccess' | translate }}
      </span>
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalPix.transferSummary' | translate }}
      </p>
    </div>
  </div>

  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>

    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>

    <div class="gw-flex gw-flex-col" *ngIf="paymentReceipt?.receiver">
      <span
        class="gw-text-text-primary gw-text-base gw-font-medium gw-mb-medium"
      >
        {{ 'features.withdrawals.modalPix.proofReceiver' | translate }}
      </span>

      <div class="gw-flex gw-flex-col">
        <p class="gw-text-text-secondary gw-m-0 gw-font-normal">
          {{ confirmedBankDisplayLine | uppercase }}
        </p>
        <p class="gw-text-text-primary gw-font-extrabold gw-m-0 gw-mt-1">
          {{ resolvedRecipientName | uppercase }}
        </p>
      </div>
    </div>

    <div
      class="gw-h-px gw-w-full gw-bg-border-normal gw-mt-medium"
      aria-hidden="true"
      *ngIf="paymentReceipt?.receiver"
    ></div>

    <span class="gw-text-text-primary gw-text-base gw-font-medium gw-mb-small">
      {{ 'features.withdrawals.modalPix.details' | translate }}
    </span>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.receiver?.holderDocument"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.cpfCnpj' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ paymentReceipt?.receiver?.holderDocument | document }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.receiver?.agency"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.agency' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ formatAgency(paymentReceipt?.receiver?.agency) }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.receiver?.account"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.checkingAccount' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ formatAccount(paymentReceipt?.receiver?.account) }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.payer?.holderName"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.proofPayer' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ paymentReceipt?.payer?.holderName }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.payer?.holderDocument"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.cpfCnpj' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ paymentReceipt?.payer?.holderDocument | document }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.id"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.proofTransactionId' | translate }}
      </span>
      <span class="gw-text-text-secondary gw-break-all">
        {{ paymentReceipt?.id }}
      </span>
    </div>
    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.e2eId"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.proofE2eId' | translate }}
      </span>
      <span class="gw-text-text-secondary gw-break-all">
        {{ paymentReceipt?.e2eId }}
      </span>
    </div>
    <div
      class="gw-h-px gw-w-full gw-bg-border-normal gw-mt-medium"
      aria-hidden="true"
    ></div>

    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalPix.proofVia' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ 'features.withdrawals.modalPix.proofMethodPix' | translate }}
      </p>
    </div>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalPix.provider' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ paymentMetadata?.provider | provider }}
      </p>
    </div>

    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalPix.proofFrequency' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{
          'features.withdrawals.modalPix.proofFrequencyImmediate' | translate
        }}
      </p>
    </div>
    <div class="gw-flex gw-flex-col" *ngIf="paymentReceipt?.date">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalPix.proofWillReceive' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{
          paymentReceipt?.date | date : 'dd MMM yyyy' : '' : 'pt-BR' | uppercase
        }}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isWithdrawalFailed">
  <div class="gw-flex gw-items-center gw-gap-small gw-mb-medium">
    <gatewee-icon
      icon="@phi.x-circle"
      class="gw-text-status-negative gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <div class="gw-flex gw-flex-col">
      <span class="gw-text-text-primary gw-text-[16px] gw-font-extrabold">
        {{ 'features.withdrawals.modalPix.transferFailed' | translate }}
      </span>
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        <ng-container *ngIf="statusErrorMessage; else transferFailedSummary">
          {{ statusErrorMessage }}
        </ng-container>
        <ng-template #transferFailedSummary>
          {{
            'features.withdrawals.modalPix.transferFailedSummary' | translate
          }}
        </ng-template>
      </p>
    </div>
  </div>
  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>
    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ confirmedBankDisplayLine | uppercase }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ resolvedRecipientName | uppercase }}
      </p>
    </div>
  </div>
</ng-container>
